import request from "../request";

/* LOGIN API */
export const adminLogin = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post("admin/auth/login", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

/* REGISTER API */
export const adminRegister = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post("admin/auth/register", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

/* CREATE NEW USER API */
export const createNewUserAPI = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post("admin/auth/create-user", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

/* UPDATE NEW USER API */
export const updateNewUserAPI = (id, data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/auth/user/${id}`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

/* DELETE USER API */
export const deleteUserAPI = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/auth/user/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

/* GET LIST OF USERS */
export const getUsersList = (page, sizePerPage, pagination) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(
        `admin/auth/user-list?page=${page}&sizePerPage=${sizePerPage}&pagination=${pagination}`
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

/* UPDATE STATUS - OFFICE */
export const updateUserStatusOffice = (id, data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/award-application/office-bearer/${id}`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

/* UPDATE STATUS - JURY */
export const updateUserStatusJury = (id, data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/award-application/jury/${id}`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

/* SEND EMAIL TO SELECTED USER */
export const sendEmailToSelected = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/award-application/send-email/selected/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

/* UPDATE APPLICATION */
export const updateApplication = (id, data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/award-application/${id}`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

/* GET FEEDBACK */
export const getFeedback = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/feedback`, { params: params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

/* DELETE FEEDBACK */
export const deleteFeedback = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/feedback/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
